import { render, staticRenderFns } from "./Steen2.vue?vue&type=template&id=7c6e24b1&"
import script from "./Steen2.vue?vue&type=script&lang=ts&"
export * from "./Steen2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports